<template>
  <div class="content-text">
    <div class="text richtext-content">
      <h2 v-if="data.title" class="title text-2xl" v-html="data.title" />
      <StructuredText
        v-if="data.content"
        class="structured-text content text-lg"
        :data="data.content"
        :render-block="renderBlock"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import renderBlock from '~/datocms/renderBlock';
import type { ContentTextFragment } from '#gql';

defineProps<{
  data: ContentTextFragment;
}>();
</script>

<style scoped lang="scss">
.content-text {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
  }

  > .richtext-content {
    display: grid;
    gap: var(--spacing-2xs);
    max-width: 900px;

    @media (--xs) {
      grid-column: 1 / -1;
    }

    @media (--xs), (--sm) {
      padding: var(--spacing-sm) 0;
    }

    @media (--sm) {
      grid-column: 2 / 24;
    }

    @media (--md), (--lg) {
      padding: var(--spacing-3xl) 0;
      grid-column: 5 / 21;
    }
  }
}
</style>
